import { createAsyncThunk } from "@reduxjs/toolkit";
import { UPDATE_PROFILE_PICTURE, GET_COMPANY_WABA_PROFILE, UPDATE_COMPANY_WABA_PROFILE } from "../../api/profile.service";

export const updateWabaProfilePic = createAsyncThunk(
    "waba-profile/update-profile-pic",
    async (payload,thunkAPI) => {
        try {
            const {data} = await UPDATE_PROFILE_PICTURE(payload);
            return data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data)
        }
    }
)

export const updateWabaProfileData = createAsyncThunk (
    "waba-profile/update-profile-data",
    async (payload,thunkAPI) => {
        try {
            const {data} = await UPDATE_COMPANY_WABA_PROFILE(payload);
            return data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data)
        }
    }
) 


export const getWabaProfileData = createAsyncThunk(
    "waba-profile/get-profile-data",
    async (_, thunkAPI) =>{
        try {
            const {data} = await GET_COMPANY_WABA_PROFILE();
            return data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data)
        }
    }
)
